import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  name: 'NewPassword',

  data() {
    return {
      valid: false,
      form: {
        token: '',
        new_password: '',
        confirm_password: ''
      },
      required(propertyType: any) {
        return (v: string) =>
            (v && v.length > 0) || `${propertyType}は入力必須項目です`
      },
      minLength(min_value: number) {
        return (v: string) =>
            (v && v.length >= min_value) || `${min_value}文字以上で入力してください`
      },
      preventJapaneseText() {
        let japanRegex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g
        return (v: any) =>
          (v && !japanRegex.test(v)) || '半角英数字、及び記号のみで入力してください。'
      }
    }
  },
  mounted() {
    const token = this.$route.params.id
    this.$store.dispatch('verifyToken', { token, type: 'RESET_PASSWORD' }).then(() => {
      this.form.token = token
    }).catch(() => {
      return this.$router.push({ path: '/reset_password/invalid' })
    })
  },

  computed: {
    ...mapState(['loading', 'message']),
    passwordConfirmationRule() {
      return () => (this.form.new_password === this.form.confirm_password) || `パスワードが一致しません`
    },
  },
  methods: {
    submit () {
      this.$store.dispatch('clearMessage')
      this.$store.dispatch('newPassword', { ...this.form }).then(() => {
        return this.$router.push({ path: '/reset_password/complete' })
      })
    },
    back() {
      this.$router.push({ path: '/login' })
    },
    preventJapaneseInput(e: any) {
      let japanRegex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g
      if (japanRegex.test(e.key)) {
        e.preventDefault()
      }
    }
  }

})
